import { render, staticRenderFns } from "./TsTicket.vue?vue&type=template&id=0feed5c8&scoped=true"
import script from "./TsTicket.vue?vue&type=script&lang=js"
export * from "./TsTicket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0feed5c8",
  null
  
)

export default component.exports